<loader *ngIf="loading"></loader>

<div *ngIf="!loading" class="rules-container">
  <div *ngIf="imagesList.length == 0 && rulesList.length == 0">
    <h2 *ngIf="!isSearchActive" class="images">
      <span>{{ "translate.general.noPageElements" | translate }}</span>
    </h2>
    <h2 *ngIf="isSearchActive" class="images">
      <span>{{ "translate.general.noResults" | translate }}</span>
    </h2>
  </div>

  <rev-doc-rule-tile
    #rulesTiles
    *ngFor="let rule of rulesList; let i = index"
    [rule]="rule"
    [isFilterActive]="isFilterActive"
    (onToggleRuleView)="onToggleRuleViewClicked(rule)"
    (onToggleRuleViewSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(rule)"
    [displayPageNum]="displayPageNum"
    [hasNext]="hasNextRule(i)"
    [hasPrev]="hasPrevRule(i)"
    (onGoToRulePage)="onGoToRulePage(rule)"
    (showNextRuleEmitter)="showNextRule(i)"
    (showPrevRuleEmitter)="showPrevRule(i)"
    (mouseenter)="onMouseEnter(rule)"
    (mouseleave)="onMouseLeave(rule)"
    (onToggleRequestedRule)="onToggleRuleViewClicked($event)"
    (onUpdateSpellingIssues)="reloadData()"
    [referenceDocuments]="referenceDocuments"
  >
  <ng-template #childTemplate>
    <ng-container *ngFor="let child of rule.children | keyvalue">
      <p-panel  *ngIf="!['Footnotes', 'Tables'].includes(child.key)"  [header]="child.key + ' (' + child.value.length +')'" 
      [toggleable]="true"
      [collapsed]="true"
      (collapsedChange)="handleToggle($event, child.key, rule)"
      [style]="{ position: 'relative', top: '-1.5em' }"
      >
            <rev-doc-rule-tile
            #phrasesChildren
            [rule]="ruleChild"
            [propagateActionFromParent]="rule.propagateActionFromParent"
            *ngFor="let ruleChild of child.value; let i1 = index"
            (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
            (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
            [displayPageNum]="displayPageNum"
            (onGoToRulePage)="onGoToRulePage(ruleChild)"
            (showNextRuleEmitter)="showNextRule(i)"
            (showPrevRuleEmitter)="showPrevRule(i)"
            (mouseenter)="onMouseEnter(ruleChild)"
            (mouseleave)="onMouseLeave(ruleChild)"
            (onUpdateSpellingIssues)="reloadData()"
            [referenceDocuments]="referenceDocuments"
          >
          </rev-doc-rule-tile>
      </p-panel>
      </ng-container>
  </ng-template>
  <ng-template #footnotesTemplate>
      <rev-doc-rule-tile
        #footnotesChildren
        *ngFor="let ruleChild of rule.children['Footnotes']"
        [rule]="ruleChild"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
  </ng-template>
  <ng-template #tablesTemplate>
      <rev-doc-rule-tile
        #footnotesChildren
        *ngFor="let ruleChild of rule.children['Tables']"
        [rule]="ruleChild"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
  </ng-template>
  <ng-template #contentTemplate>
        <rev-doc-rule-tile
        *ngFor="let ruleChild of rule.contentChildren"
        [rule]="ruleChild"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        #phrasesContentChildren
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
  </ng-template>
  <ng-template #imageTemplate>
        <rev-doc-rule-tile
        *ngFor="let ruleChild of rule.imageChildren"
        [rule]="ruleChild"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        #phrasesImageChildren
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
    </ng-template>
</rev-doc-rule-tile>

  <div *ngIf="imagesList.length">
    <h2 class="images">
      <span>{{ "translate.general.images" | translate }}</span>
    </h2>
    <rev-doc-rule-tile
      #imageTiles
      *ngFor="let rule of imagesList; let i = index"
      [rule]="rule"
      [hasNext]="hasNextImage(i)"
      [hasPrev]="hasPrevImage(i)"
      (onToggleRuleView)="onToggleRuleViewClicked(rule)"
      (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(rule)"
      [displayPageNum]="displayPageNum"
      (onGoToRulePage)="onGoToRulePage(rule)"
      (showNextRuleEmitter)="showNextImage(i)"
      (showPrevRuleEmitter)="showPrevImage(i)"
      (mouseenter)="onMouseEnter(rule)"
      (mouseleave)="onMouseLeave(rule)"
      (onToggleRequestedRule)="onToggleRuleViewClicked($event)"
      (onUpdateSpellingIssues)="reloadData()"
      [referenceDocuments]="referenceDocuments"
    >
  <ng-template #childTemplate>
      <p-panel  [header]="child.key" *ngFor="let child of rule.children | keyvalue"
      [toggleable]="true"
      [collapsed]="true"
      >
        <rev-doc-rule-tile
        *ngFor="let ruleChild of child.value; let i1 = index"
        [rule]="ruleChild"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        #imagesChildren
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
    </p-panel>
  </ng-template>
  <ng-template #contentTemplate>
      <rev-doc-rule-tile
        *ngFor="let ruleChild of rule.contentChildren"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        [rule]="ruleChild"
        #imagesContentChildren
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
  </ng-template>
  <ng-template #imageTemplate>
        <rev-doc-rule-tile
        *ngFor="let ruleChild of rule.imageChildren"
        [rule]="ruleChild"
        [propagateActionFromParent]="rule.propagateActionFromParent"
        #imagesImageChildren
        (onToggleRuleView)="onToggleRuleViewClicked(ruleChild)"
        (onToggleRuleViewClickedSwitchDisabled)="onToggleRuleViewClickedSwitchDisabled(ruleChild)"
        [displayPageNum]="displayPageNum"
        (onGoToRulePage)="onGoToRulePage(ruleChild)"
        (showNextRuleEmitter)="showNextRule(i)"
        (showPrevRuleEmitter)="showPrevRule(i)"
        (mouseenter)="onMouseEnter(ruleChild)"
        (mouseleave)="onMouseLeave(ruleChild)"
        (onUpdateSpellingIssues)="reloadData()"
        [referenceDocuments]="referenceDocuments"
      >
      </rev-doc-rule-tile>
    </ng-template>
</rev-doc-rule-tile>
  </div>
</div>
